import { Link, useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";

const TOKEN_KEY = "arteconciencia_admin_token_v1";

/**
 * Shared header for admin sections.
 * - Sits above the page content on /admin, /admin/obras and /admin/visitas.
 * - Highlights the active tab.
 * - Provides a single logout point.
 */
export default function AdminHeader({ onLogout }) {
  const { pathname } = useLocation();
  const tabs = [
    { to: "/admin", label: "Panel" },
    { to: "/admin/obras", label: "Obras" },
    { to: "/admin/visitas", label: "Visitas Guiadas" },
    { to: "/admin/catalogo", label: "Catálogo" },
  ];
  const handleLogout = () => {
    if (onLogout) onLogout();
    else {
      localStorage.removeItem(TOKEN_KEY);
      window.location.reload();
    }
  };
  return (
    <div className="border-b border-line bg-paper-raised" data-testid="admin-header">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-1 sm:gap-2 flex-wrap">
          <span className="font-ui uppercase tracking-[0.22em] text-[0.62rem] text-latir-red mr-2">
            Admin LATIR
          </span>
          {tabs.map((t) => {
            const active =
              t.to === pathname ||
              (t.to === "/admin/obras" && pathname.startsWith("/admin/obras")) ||
              (t.to === "/admin/visitas" && pathname.startsWith("/admin/visitas"));
            return (
              <Link
                key={t.to}
                to={t.to}
                data-testid={`admin-nav-${t.to.replace(/\//g, "-")}`}
                className={
                  "font-ui uppercase tracking-[0.18em] text-[0.66rem] px-3 py-1.5 rounded-[3px] transition-colors " +
                  (active
                    ? "bg-ink text-paper"
                    : "text-ink-soft hover:text-ink hover:bg-paper-deep")
                }
              >
                {t.label}
              </Link>
            );
          })}
        </div>
        <button
          onClick={handleLogout}
          className="inline-flex items-center gap-2 font-ui uppercase tracking-[0.2em] text-[0.66rem] text-ink-soft hover:text-latir-red transition-colors"
          data-testid="admin-header-logout"
        >
          <LogOut className="w-4 h-4" strokeWidth={1.4} /> Cerrar sesión
        </button>
      </div>
    </div>
  );
}
